import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Kvartspris = lazy(() => import("@/pages/elavtal/Kvartspris"));

export const Route = createFileRoute("/elavtal/kvartspris")({
  head: () => seoHead("/elavtal/kvartspris"),
  component: () => <Kvartspris />,
});
